
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { createElement as jsx } from '../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';
import 'react';
import { container } from './styles.js';
import { u as useTheme } from '../../../node_modules/@emotion/react/dist/emotion-element-5486c51c.browser.esm.js';
import PulseLoader from '../../../node_modules/react-spinners/esm/PulseLoader.js';
import ClipLoader from '../../../node_modules/react-spinners/esm/ClipLoader.js';

var _excluded = ["fullScreen", "size", "type"];
var loaderSize = {
  pulse: {
    md: "0.375rem",
    lg: "0.75rem"
  },
  clip: {
    md: "1.5rem",
    lg: "2rem"
  }
};
var loaderMargin = {
  pulse: {
    md: "0.0625rem",
    lg: "0.625rem"
  },
  clip: {
    md: "0.5rem",
    lg: "0.5rem"
  }
};
var Loader = function Loader(_ref) {
  var _ref$fullScreen = _ref.fullScreen,
    fullScreen = _ref$fullScreen === void 0 ? false : _ref$fullScreen,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "lg" : _ref$size,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? "pulse" : _ref$type,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useTheme = useTheme(),
    loader = _useTheme.loader;
  var Loader = type === "pulse" ? PulseLoader : ClipLoader;
  return jsx("div", _extends({
    css: function css() {
      return container({
        fullScreen: fullScreen
      });
    },
    "data-testid": "loader"
  }, rest, {
    className: "loading-container".concat(rest !== null && rest !== void 0 && rest.className ? "".concat(rest === null || rest === void 0 ? void 0 : rest.className) : "")
  }), jsx(Loader, {
    color: loader.color,
    size: loaderSize[type][size],
    margin: loaderMargin[type][size],
    className: "loader-wrapper"
  }));
};

export { Loader as default };
//# sourceMappingURL=Loader.js.map
